import { render, staticRenderFns } from "./ChooseBranchDialog.vue?vue&type=template&id=9631b1ac&scoped=true&"
import script from "./ChooseBranchDialog.vue?vue&type=script&lang=js&"
export * from "./ChooseBranchDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChooseBranchDialog.vue?vue&type=style&index=0&id=9631b1ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9631b1ac",
  null
  
)

export default component.exports
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTabs,QInnerLoading,QSpinnerGears,QTab});
